(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsNewCategoryController', CmsNewCategoryController);

  /* ngInject */
  function CmsNewCategoryController($state, Flash, cmsCategoryService, formErrorsService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.category = {};
    vm.categoryForm = {};
    vm.createCategory = createCategory;

    function createCategory() {
      cmsCategoryService(sessionService.getAuthToken()).save(vm.category, _createCategorySuccess, _createCategoryFailure);
    }

    function _createCategorySuccess(response) {
      Flash.create('success', 'Category successfully created.');
      $state.go('application.compliance_services.cms_edit_category', { id: response.id });
    }

    function _createCategoryFailure(response) {
      Flash.create('danger', 'An error occurred with the submission. Please correct the errors below and resubmit.');
      vm.setFormErrors(vm.categoryForm, response);
    }
  }
})();
